import { FormValidationService } from '../../../../../shared/services/formValidation/form-validation.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { ModalFolder } from 'src/app/shared/models/folder';

@Component({
  selector: 'app-add-folder-and-edit-name-folder',
  templateUrl: './add-folder-and-edit-name-folder.component.html',
  styleUrls: ['./add-folder-and-edit-name-folder.component.scss'],
})
export class AddFolderAndEditNameFolderComponent implements OnInit {
  addFolderForm: FormGroup;
  @Input() addFolderAndEditNameFolder: ModalFolder;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    public formValidationService: FormValidationService,
  ) {}

  ngOnInit(): void {
    this.addFolderForm = this.formBuilder.group({
      nameFolder: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(120),
        ],
      ],
    });

    this.addFolderForm.patchValue({
      nameFolder: this.addFolderAndEditNameFolder.nameFolder,
    });
  }

  addNewFolder(): void {
    this.activeModal.close();
  }

  onCancel() {
    this.activeModal.close();
  }
}
